import React, { useState } from 'react';

const Login = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (credentials.username === '1' && credentials.password === '1') {
      localStorage.setItem('username', credentials.username);
      onLogin();
    } else
      if (credentials.username === 'test' && credentials.password === 'test') {
        localStorage.setItem('username', credentials.username);
        onLogin();
      } else {
        alert('Invalid credentials. Please use username: 1 and password: 1');
      }
  };

  return (
    <div style={styles.container}>
      <div style={styles.videoBackground}>
        <video autoPlay muted loop style={styles.video}>
          <source src="https://assets.mixkit.co/videos/preview/mixkit-aerial-view-of-a-busy-city-street-1250-large.mp4" type="video/mp4" />
        </video>
      </div>

      <div style={styles.loginContainer}>
        <div style={styles.grabLogo}>
          {/* Grab logo using SVG */}
          <img
            src="https://assets.grab.com/wp-content/uploads/media/grab_logo.png"
            alt="Grab Logo"
            className="grab-logo-img"
          />
        </div>

        <form style={styles.loginForm} onSubmit={handleSubmit}>
          <h2 style={styles.title}>Analytics Dashboard</h2>

          <div style={styles.formGroup}>
            <label htmlFor="username" style={styles.label}>Username</label>
            <input
              type="text"
              id="username"
              value={credentials.username}
              onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
              placeholder="Enter your username"
              style={styles.input}
              required
            />
          </div>

          <div style={styles.formGroup}>
            <label htmlFor="password" style={styles.label}>Password</label>
            <input
              type="password"
              id="password"
              value={credentials.password}
              onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
              placeholder="Enter your password"
              style={styles.input}
              required
            />
          </div>

          <button type="submit" style={styles.loginBtn}>Login to Dashboard</button>

          <div style={styles.demoHint}>
            <i className="fas fa-info-circle" style={styles.icon}></i>
            Demo credentials: username : <strong>test</strong>, password : <strong>test</strong>
          </div>
        </form>

        <div style={styles.grabImages}>
          <img src="https://cdn.techinasia.com/cloudinary/transformations/wp-content/uploads/2022/12/1671784288_0ec79dbfb027da6808cae274f06a9593_v1671784288_xlarge.webp" alt="Grab Car" style={styles.image} />
          <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRNOSF1MkVQlOf39c2HmgL5SGDFI-6dHD8mtQ&s" alt="Grab Food" style={styles.image} />
          <img src="https://www.decisionlab.co/hubfs/Pages/Cases/grabBikeCase.jpg" alt="Grab Delivery" style={styles.image} />
        </div>

        <div style={styles.footer}>
          <p>&copy; 2025 Grab Analytics Dashboard. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    background: 'linear-gradient(120deg, #00a850, #006c33)',
    padding: '20px',
    overflow: 'hidden',
    position: 'relative',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
  },
  videoBackground: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: -1,
    overflow: 'hidden'
  },
  video: {
    minWidth: '100%',
    minHeight: '100%',
    objectFit: 'cover',
    opacity: 0.15
  },
  loginContainer: {
    width: '100%',
    maxWidth: '420px',
    padding: '25px',
    background: 'rgba(255, 255, 255, 0.95)',
    borderRadius: '20px',
    boxShadow: '0 15px 35px rgba(0, 0, 0, 0.2)',
    overflow: 'hidden',
    position: 'relative'
  },
  grabLogo: {
    textAlign: 'center',
    marginBottom: '25px'
  },
  loginForm: {
    width: '100%'
  },
  title: {
    textAlign: 'center',
    marginBottom: '25px',
    color: '#333',
    fontWeight: '600'
  },
  formGroup: {
    marginBottom: '20px',
    position: 'relative'
  },
  label: {
    display: 'block',
    marginBottom: '8px',
    fontWeight: '500',
    color: '#333'
  },
  input: {
    width: '100%',
    padding: '14px 15px',
    border: '2px solid #ddd',
    borderRadius: '10px',
    fontSize: '16px',
    transition: 'all 0.3s'
  },
  loginBtn: {
    width: '100%',
    padding: '14px',
    background: '#00a850',
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s',
    marginTop: '10px'
  },
  demoHint: {
    textAlign: 'center',
    marginTop: '20px',
    padding: '12px',
    background: '#f0f9ff',
    borderRadius: '10px',
    color: '#006c33',
    fontSize: '14px',
    borderLeft: '4px solid #00a850'
  },
  icon: {
    marginRight: '8px'
  },
  footer: {
    textAlign: 'center',
    marginTop: '25px',
    color: '#666',
    fontSize: '14px'
  },
  grabImages: {
    display: 'flex',
    justifyContent: 'center',
    gap: '15px',
    marginTop: '25px'
  },
  image: {
    width: '80px',
    height: '80px',
    objectFit: 'cover',
    borderRadius: '12px',
    border: '2px solid white',
    boxShadow: '0 5px 10px rgba(0, 0, 0, 0.1)'
  }
};

export default Login;